var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('partsColor',{ref:"partsColor",attrs:{"product":_vm.product},on:{"colorChanged":_vm.colorChanged}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54349b64","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/families/penta/PentaToplanti.vue
// module id = null
// module chunks = 